// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import hooks
import { useCallback } from 'react';
import {
  useCreateConfigurationPlanningEntityDynamically,
  useDeleteConfigurationPlanningEntityDynamically
} from './rapiniWrappers';

export function useAIMatchCrudPlanningEntity() {
  const createMutation = useCreateConfigurationPlanningEntityDynamically();
  const deleteMutation = useDeleteConfigurationPlanningEntityDynamically();

  const createPlanningEntity = useCallback(
    async (entityId: string, onComplete?: (error?: any) => void) => {
      try {
        const data = await createMutation.mutateAsync(entityId);

        if (
          data?.notifications?.some(
            (n) => n.text === 'maximum.number.of.organizational.units.exceeded'
          )
        ) {
          if (onComplete) onComplete(data);
        } else {
          showSuccessSnackbar();
          if (onComplete) onComplete();
        }
      } catch (error) {
        showErrorSnackbar();
        if (onComplete) onComplete(error);
      }
    },
    [createMutation]
  );

  const deletePlanningEntity = useCallback(
    async (entityId: string, onComplete?: (error?: any) => void) => {
      try {
        const data = await deleteMutation.mutateAsync(entityId);

        if (
          data &&
          !data.success &&
          data.notifications &&
          data.notifications.length > 0
        ) {
          if (onComplete) onComplete(data);
        } else {
          showSuccessSnackbar();
          if (onComplete) onComplete();
        }
      } catch (error) {
        showErrorSnackbar();
        if (onComplete) onComplete(error);
      }
    },
    [deleteMutation]
  );

  const isLoading = createMutation.isLoading || deleteMutation.isLoading;

  return {
    createPlanningEntity,
    deletePlanningEntity,
    isLoading
  };
}
